import { render, staticRenderFns } from "./LogCorrector.vue?vue&type=template&id=d0a4cc22&"
import script from "./LogCorrector.vue?vue&type=script&lang=js&"
export * from "./LogCorrector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports